import React, { useState } from "react";
import ProjectCard from "./ProjectCard";

const projectData = [
  {
    header: true,
    title: "Session App UI/UX",
    type: "UI/UX",
    paragraph: "Chat app for educational with a session system",
    skills: ["XD", "illustrator"],
    img: require("../assets/session.png"),
    button: "Behance",
    link: "https://www.behance.net/gallery/113313639/session-app",
    dir: "ltr",
  },
  {
    title: "WallPost Website",
    type: "Front-end",
    paragraph: "Landing page for a Cloud based ERP solution",
    skills: ["HTML5", "CSS3", "JS", "jquery", "bootstrap 4"],
    img: require("../assets/wallpost.png"),
    button: "Visit Website",
    link: "https://wallpostsoftware.com/global/",
    dir: "rtl",
  },
  {
    title: "Nidaa Org Website",
    type: "UI/UX",
    paragraph: "A website design for a non-profit organization",
    skills: ["Figma", "illustrator"],
    img: require("../assets/nidaa-org.png"),
    button: "Behance",
    link: "https://www.behance.net/gallery/157063923/_",
    dir: "ltr",
    seeMore: true,
  },
];

const Projects = () => {
  return (
    <section id="projects" className="container m-auto mb-20 px-4 md:px-0">
      <div className="h-screen bg-background flex flex-col justify-center items-center gap-10 text-center">
        {projectData.map((project, index) => (
          <ProjectCard key={index} {...project} />
        ))}
      </div>
    </section>
  );
};

export default Projects;
